export default __webpack_public_path__ + "static/media/Brands.4bf88dc7.svg";